import { useState, useRef } from 'react';
import { PTextFieldWrapper } from "@porsche-design-system/components-react";

export interface ITextFieldProps {
  placeholder: string;
  value?: string,
  className?: string,
  onChange?: (value: string) => void;
  disabled?: boolean;
  label?:string;
  isError?: boolean;
  errorMsg?: string;
  id? : string;
}

const TextField = (props: ITextFieldProps) => {
  const inputRef = useRef(null);
  const [value, setValue] = useState("");
  const fieldValue = props.value !== undefined ? props.value : value

  return (
    <PTextFieldWrapper label={props.label}
      state={props.isError === true ? "error" : 'none'} autoFocus={false} inert={false}>
              <input
                ref={inputRef}
                autoFocus={false}
                inert={false}
                id={props.id}
                value={fieldValue}
                placeholder={props.placeholder}
                type="text"
                disabled={props.disabled}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  props.onChange && props.onChange(inputValue);
                  setValue(inputValue);
                }}
              />
      <span slot="message" id={"error-message-"+props.id} className="validation-message">{props.errorMsg}</span>
    </PTextFieldWrapper>

  )
};

export default TextField;
